import { Entidad } from "../../../../data/Entidad";
import _L from "../../../../util/Labels";
import { Button } from "../../../controlD3/Button";
import { FormGenerator } from "../../../controlD3/Formulario";
import { ModalThingsUtil } from "../../../controlD3/ModalThings/Utils";
import { UIUtilTime } from "../../../util/Time";
import { AlumnoEdoCtaUtil } from "../AlumnoEdoCtaUtil";
import { AlEdoCtaPagoFormUtil } from "./Util";

type IDataForm = AlEdoCtaPagoFormUtil.IDataForm;
type IMetodoPago = Entidad.IFinanzaMetodoPago;

export class ProcesoPago4DateAndMethodView {
    private container: HTMLDivElement;
    private form: FormGenerator<IDataForm>;

    public get _Node(): HTMLDivElement {
        return this.container;
    }

    public get _FormData(): IDataForm {
        return this.form._Data;
    }

    public get _FormControls(): typeof this.form._ControlsData {
        return this.form._ControlsData;
    }

    constructor(
        private modalThings: ModalThingsUtil.IModalThings,
        private procesoPagoData: AlEdoCtaPagoFormUtil.IDataForm,
        private metodosPagoList: IMetodoPago[]
    ) {
        const { modalThings: mt } = this;
        const inicializarFechaAHoy = (procesoPagoData.FechaPagoUTC == null);

        this.container = document.createElement("div");
        this.container.className = "proceso_pago3_date_and_method_view_container";

        const inputTimePago = document.createElement("input");
        inputTimePago.type = "time";
        inputTimePago.className = "input-form";

        this.form = new FormGenerator<IDataForm>()
            ._Crear({
                LangModuleKeyInContext: AlumnoEdoCtaUtil.MODULO_LANG_KEY,
                LabelMaxWidth: 140,
                schema: [
                    {
                        model: "IdMetodoPago",
                        type: "selectMaterial",
                        labelAttr: { text: "tag_paymtd" },
                        selectMaterialAttr: {
                            valueMember: "IdMetodoPago",
                            displayMember: "Nombre",
                            onSelect: (datoMP: IMetodoPago) => {
                                Button._EnableButton(mt.BtnRight, Boolean(datoMP));
                            }
                        },
                        values: metodosPagoList
                    },
                    {
                        model: "FechaPagoUTC",
                        type: "input",
                        labelText: _L("general.fechapago"),
                        inputAttr: {
                            type: "date",
                            step: "1",
                            required: true,
                            max: UIUtilTime._FmtToInputDate(new Date()),
                            onchange: (ev) => {
                                const target = (ev.target as HTMLInputElement);
                                const today = new Date();
                                const isToday = (target.value == UIUtilTime._FmtToInputDate(today));
                                if (isToday) {
                                    inputTimePago.value = UIUtilTime._FmtToInputTime(today);
                                } else {
                                    inputTimePago.value = "00:00";
                                }
                            }
                        },
                        onGetFixedValue: (value: string) => {
                            if (!value) return null;
                            if (inputTimePago.value == "") {
                                inputTimePago.value = "00:00";
                            }
                            const [hours, minutes] = inputTimePago.value.split(":").map(Number);
                            const dateParts = value.split("-").map(Number);
                            const dateValue = new Date(dateParts[0], dateParts[1] - 1, dateParts[2], hours, minutes);
                            console.warn("FechaPagoUTC fixed:", dateValue, dateValue.toISOString());
                            return dateValue.toISOString()
                        },
                        onLoad: (control, thisForm) => {
                            control.controlWrapper
                                .style("display", "flex")
                                .style("gap", "var(--padding1)")
                                .append(() => inputTimePago);
                        },
                    },
                ],
                Validation: (val) => Boolean(val)
            }, procesoPagoData);

        if (inicializarFechaAHoy) {
            const fechaPago = new Date();
            this.form._SetModelValue("FechaPagoUTC", UIUtilTime._FmtToInputDate(fechaPago));
            inputTimePago.value = UIUtilTime._FmtToInputTime(fechaPago);
        }

        this.container.appendChild(this.form._Form.node());
    }

    public _Valide(): boolean {
        return this.form._GetIsValidForm();
    }
}